import { render, staticRenderFns } from "./ExpandTop.vue?vue&type=template&id=0d080ec6&scoped=true&"
import script from "./ExpandTop.vue?vue&type=script&lang=js&"
export * from "./ExpandTop.vue?vue&type=script&lang=js&"
import style0 from "./ExpandTop.vue?vue&type=style&index=0&id=0d080ec6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d080ec6",
  null
  
)

export default component.exports